'use client'

import { Box, Card, CardContent, Stack } from '@mui/material'
import { capitalize } from 'lodash'
import { Logger, TextBlock, Typography } from '@wolfdanepug/common-react'
import { useMemo } from 'react'
import { paymentBrandIcons } from '../../constants'

export default function PaymentMethodCard({ item: paymentMethod, loading }: any) {
	Logger.log('[PaymentMethodCard]', { paymentMethod, loading })
	const item = paymentMethod.reference

	const paymentMethodIcon = useMemo(() => {
		const brand = item?.card?.brand
		if (!brand) return null
		return paymentBrandIcons[brand]
	}, [item?.card?.brand])

	const address = [
		item?.billingDetails?.address?.line1,
		item?.billingDetails?.address?.line2,
		item?.billingDetails?.address?.postalCode,
		item?.billingDetails?.address?.city,
		item?.billingDetails?.address?.state,
		item?.billingDetails?.address?.country
	]
		.filter(Boolean)
		.join(', ')

	return (
		<Card sx={{ borderRadius: 2 }}>
			<CardContent>
				<Box>
					{paymentMethodIcon && (
						<Box component={'img'} src={paymentMethodIcon} sx={{ height: 50 }} />
					)}
				</Box>

				<Stack spacing={2}>
					<Typography variant="h6" loading={loading}>
						{capitalize(item?.card.brand)} ****{item?.card.last4} | {item?.card.expMonth}/
						{item?.card?.expYear.toString().slice(-2)}
					</Typography>
					<TextBlock title={item?.billingDetails?.name} text={address} />
				</Stack>
			</CardContent>
			{/* <CardActions sx={{ justifyContent: 'flex-end' }}>
				<Button LinkComponent={Link} size="small" color="primary" href="/subscription">
					1 Gourmet Dog Food Subscription
				</Button>
				<Dropdown
					onClick={(action: any) => Logger.log('[PaymentMethodCard]', { action })}
					icon={MoreHoriz}
					items={[
						{
							label: 'Delete',
							url: `/dashboard/payment-methods/${paymentMethod.id}/delete`
							// event: 'delete'
						}
					]}
				/>
			</CardActions> */}
		</Card>
	)
}
